__turbopack_context__.v({
  "avatar": "WorkExperienceSection-module-scss-module__ZvPBUq__avatar",
  "avatarCurrent": "WorkExperienceSection-module-scss-module__ZvPBUq__avatarCurrent",
  "avatarImg": "WorkExperienceSection-module-scss-module__ZvPBUq__avatarImg",
  "avatarRing": "WorkExperienceSection-module-scss-module__ZvPBUq__avatarRing",
  "cardReveal": "WorkExperienceSection-module-scss-module__ZvPBUq__cardReveal",
  "driftA": "WorkExperienceSection-module-scss-module__ZvPBUq__driftA",
  "driftB": "WorkExperienceSection-module-scss-module__ZvPBUq__driftB",
  "entry": "WorkExperienceSection-module-scss-module__ZvPBUq__entry",
  "header": "WorkExperienceSection-module-scss-module__ZvPBUq__header",
  "headerLeft": "WorkExperienceSection-module-scss-module__ZvPBUq__headerLeft",
  "rotateSlow": "WorkExperienceSection-module-scss-module__ZvPBUq__rotateSlow",
  "shell": "WorkExperienceSection-module-scss-module__ZvPBUq__shell",
  "subtitle": "WorkExperienceSection-module-scss-module__ZvPBUq__subtitle",
  "timeline": "WorkExperienceSection-module-scss-module__ZvPBUq__timeline",
  "timelineLeft": "WorkExperienceSection-module-scss-module__ZvPBUq__timelineLeft",
  "title": "WorkExperienceSection-module-scss-module__ZvPBUq__title",
});
